import { useCallback, useRef } from "react";

// Returns a stable function identity that always invokes the latest `fn` (no stale closures,
// safe to list in effect dependency arrays without re-triggering the effect).
export function useStableCallback(fn) {
  const ref = useRef(fn);
  ref.current = fn;
  return useCallback((...args) => ref.current(...args), []);
}
